document.addEventListener("DOMContentLoaded", function () {
  var swipersocial = new Swiper(".reviewmedia__v2--linksinner", {
    slidesPerView: 1.2,
    spaceBetween: 16,
    arrow: false,
    scrollbar: {
      el: ".swiper-scrollbar.reviewmedia",
      draggable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next.reviewmedia",
      prevEl: ".swiper-button-prev.reviewmedia",
    },
    breakpoints: {
      640: {
        slidesPerView: 1.2,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 16,
      },
    },
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var playButtons = document.querySelectorAll(".play__button");
  var allVideos = document.querySelectorAll(".social__content--video video");

  playButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      var parentDiv = button.closest(".socialpost--main");
      var clickedVideo = parentDiv.querySelector(".social__content--video video");
      var videoPoster = parentDiv.querySelector(".image__poster");

      // Pause all other videos
      allVideos.forEach(function (video) {
        if (video !== clickedVideo) {
          video.pause();
        }
      });

      // Play this video
      clickedVideo.play();
      clickedVideo.controls = true;
      videoPoster.style.display = "none";
    });
  });

  allVideos.forEach(function (video) {
    video.addEventListener("pause", function () {
      var videoParent = video.closest(".socialpost--main");
      var videoPoster = videoParent.querySelector(".image__poster");
      video.controls = false;
      videoPoster.style.display = "block";
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  let swipericons = null;

  function initSwiperIfNeeded() {
    if (window.innerWidth < 873 && !swipericons) {
      swipericons = new Swiper(".main__iconsv2--inner", {
        slidesPerView: 1,
        spaceBetween: 16,
        scrollbar: {
          el: ".swiper-scrollbar.icons",
        },
        navigation: {
          nextEl: ".swiper-button-next.vcategory",
          prevEl: ".swiper-button-prev.vcategory",
        },
      });
    }
  }

  // Check on page load
  initSwiperIfNeeded();

  // Check again on resize
  window.addEventListener("resize", function () {
    initSwiperIfNeeded();
  });
});
